import { getCoreSettings } from '../model/core-settings';
import { fetchMEventsAPI } from './fetch-m-events-api';
import { fetchProduction } from './fetch-production';

/**
 * appConfig can come from the following sources:
 * 1. in DEV environment
 *   - from locally saved file: public/cms-settings/production/app_config_false.json
 *   - from m-events API
 * 2. in production from {origin}/cms-settings/production/app_config_false.json
 */
export const fetchAppConfig = async () => {
  const coreSettings = getCoreSettings();

  if (coreSettings.appConfigFrom === 'm-events') return fetchMEventsAPI(coreSettings);

  return fetchProduction();
};
